import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { InhertLinkDirective} from './inhert-link.directve';
import { HideElementDirective } from "../hide-element/hide-element.ditective";
import { UpdateScrollBarDirective } from "./scrollbar-update.directive";

@NgModule({
    imports:[CommonModule],
    declarations: [
        InhertLinkDirective,
        HideElementDirective,
        UpdateScrollBarDirective
        
    ],
    exports:[
        InhertLinkDirective,
        HideElementDirective,
        UpdateScrollBarDirective
    ]    
})

export class LinkModule{}